module.exports = __webpack_public_path__ + "img/pin.e782e903.svg";